import type { BuildingType, UnitType } from './types';

export interface BuildingDef {
  type: BuildingType;
  label: string;
  income: number; // gold per turn (0 = no income)
  recruits: UnitType[] | null; // unit types it can produce (null = none)
  icon: string;
  defenseBonus?: number; // defense multiplier; overrides terrain when the building is complete (default: 1.0)
  repairsAll?: boolean; // if true, building repairs ALL unit types (HQ special case)
}

export const BUILDING_DEFS: Record<BuildingType, BuildingDef> = {
  hq: {
    type: 'hq',
    label: 'hq',
    income: 200,
    recruits: ['supply-truck', 'medic', 'officer'],
    icon: '/units/hq-map-icon.png',
    repairsAll: true,
  },
  city: {
    type: 'city',
    label: 'city',
    income: 100,
    recruits: null,
    icon: '/units/city-map-icon.png',
  },
  barracks: {
    type: 'barracks',
    label: 'barracks',
    income: 0,
    recruits: ['infantry', 'infantry-bazooka', 'recon', 'cavalry'],
    icon: '/units/barracks-map-icon.png',
  },
  'vehicle-factory': {
    type: 'vehicle-factory',
    label: 'vehicle-factory',
    income: 0,
    // Tracked vehicles only — wheeled vehicles moved to motor-pool below.
    recruits: ['light-tank', 'medium-tank', 'heavy-tank', 'aa-flakpanzer', 'tank-destroyer'],
    icon: '/units/factory-map-icon.png',
  },
  'motor-pool': {
    type: 'motor-pool',
    label: 'motor-pool',
    income: 0,
    // Wheeled vehicles — formerly produced by vehicle-factory + barracks.
    recruits: ['jeep', 'apc', 'anti-tank-artillery', 'long-range-artillery'],
    icon: '/units/motor-pool-map-icon.png',
  },
  airport: {
    type: 'airport',
    label: 'airport',
    income: 0,
    recruits: ['plane-fighter', 'plane-bomber', 'plane-transport'],
    icon: '/units/airport-map-icon.png',
  },
  port: {
    type: 'port',
    label: 'port',
    income: 0,
    recruits: ['ship-battleship', 'ship-submarine', 'ship-transport', 'ship-aircraft-carrier'],
    icon: '/units/port-map-icon.png',
  },
  bunker: {
    type: 'bunker',
    label: 'bunker',
    income: 0,
    recruits: null,
    icon: '/units/bunker-map-icon.png',
    defenseBonus: 2.5,
  },
};
